import * as React from 'react';
import "./Panel.scss";

export default class Panel extends React.Component<React.HTMLAttributes<HTMLParagraphElement>>{

    public render() {

        const defaultStyle = {
            minWidth: "100%",
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            ...this.props.style
        };

        return (
            <div style={defaultStyle} className={`panel ${this.props.className ? this.props.className : ''}`}>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Panel/Panel.tsx